"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToRelax() {
  const tickerItems = Array(10).fill("COMFORT • RELIABILITY • CLEANLINESS • ");
  return <section id="ready-to-relax" className="dark bg-background text-foreground relative flex flex-col items-center justify-center overflow-hidden py-48">
      <style>{`
        @keyframes ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>

      {}
      <div className="absolute top-0 left-0 w-full overflow-hidden border-b border-border/20 py-3">
        <div className="flex w-max whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground" style={{
        animation: "ticker-scroll 40s linear infinite"
      }}>
          <div className="flex px-4">
            {tickerItems.map((item, i) => <span key={`top-1-${i}`} data-index={i}>
                {item}
              </span>)}
          </div>
          <div className="flex px-4">
            {tickerItems.map((item, i) => <span key={`top-2-${i}`} data-index={i}>
                {item}
              </span>)}
          </div>
        </div>
      </div>

      {}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/praise_space_logo_watermark.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/praise_space_logo_watermark.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/praise_space_logo_watermark.png-wvc-sizes" alt="Praise Space Watermark" className="pointer-events-none absolute top-1/2 left-1/2 w-[120vw] max-w-[1200px] -translate-x-1/2 -translate-y-1/2 opacity-10 grayscale md:w-[80vw]" loading="lazy" />

      {}
      <div className="relative z-10 flex w-full max-w-4xl flex-col items-center px-6 text-center">
        <h2 className="font-default text-[clamp(3rem,6vw,5rem)] font-normal leading-[1.1] tracking-tight text-foreground">
          <span className="inline-block -translate-y-4 md:-translate-y-8">
            Ready
          </span>{" "}
          to Relax?
        </h2>

        <div className="mt-16">
          <Link to="/ContactPage">
            <Button variant="default" size="lg" className="h-auto rounded-sm px-8 py-4 text-sm font-medium uppercase tracking-widest shadow-lg transition-transform hover:scale-105">
              Book Your Stay
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden border-t border-border/20 py-3">
        <div className="flex w-max whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground" style={{
        animation: "ticker-scroll 40s linear infinite reverse"
      }}>
          <div className="flex px-4">
            {tickerItems.map((item, i) => <span key={`bottom-1-${i}`} data-index={i}>
                {item}
              </span>)}
          </div>
          <div className="flex px-4">
            {tickerItems.map((item, i) => <span key={`bottom-2-${i}`} data-index={i}>
                {item}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}